// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import axios from "axios";
import { message } from "ant-design-vue";
import store from "@/store";
import router from "@/router";
import { setToken } from "@/utils/auth";
import Cookies from "js-cookie";

// import { getToken } from "@/utils/auth";
import SettingMer from "@/utils/settingMer";
const service = axios.create({
  baseURL: SettingMer.apiBaseURL,
  timeout: 60000, // 过期时间
});

// request interceptor
service.interceptors.request.use(
  (config) => {
    // 发送请求之前做的
    const token = !store.getters.token
      ? localStorage.getItem("token")
      : store.getters.token;
    if (token && !config.isNoloading) {
      config.headers["Token"] = token;
    }
    if (/get/i.test(config.method)) {
      config.params = config.params || {};
      config.params.temp = Date.parse(new Date()) / 1000;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    // if the custom code is not 20000, it is judged as an error.
    if (res.code === 401) {
      // to re-login
      message.error("无效的会话，或者登录已过期，请重新登录。");
      store.dispatch("user/resetToken");
      localStorage.setItem("token", "");
      localStorage.removeItem("userInfo");
      Cookies.set("JavaInfo", "");
      setToken("");
      router.replace({ path: "/login" });
    } else if (res.code === 403) {
      message.error("没有权限访问。");
    }
    if (res.code !== 200 && res.code !== 401) {
      message.error(res.msg || "Error");
      return Promise.reject();
    } else {
      return res.data;
    }
  },
  (error) => {
    message({
      message: error.msg,
      type: "error",
      duration: 5 * 1000,
    });
    return Promise.reject(error);
  }
);

export default service;
